import { memo } from "react";
import { InvoiceWidgetProps } from "./types";
import { useTranslate } from "helpers";
import { Tabs } from "ui/components/Tabs";
import InvoiceStatsTab from "./components/InvoiceStatsTab/InvoiceStatsTab";
import InvoiceSaleSearchTab from "./components/InvoiceSearchTab/InvoiceSaleSearchTab";
import InvoiceRentSearchTab from "./components/InvoiceSearchTab/InvoiceRentSearchTab";

const InvoiceWidget: React.FC<InvoiceWidgetProps> = () => {
  const { t } = useTranslate();

  return (
    <Tabs
      tabs={[
        {
          label: t("admin.dashboard.widget.invoices.tab.stats.title"),
          content: <InvoiceStatsTab />,
        },
        {
          label: t("admin.dashboard.widget.invoices.tab.search.sale.title"),
          content: <InvoiceSaleSearchTab />,
        },
        {
          label: t("admin.dashboard.widget.invoices.tab.search.rent.title"),
          content: <InvoiceRentSearchTab />,
        },
      ]}
    />
  );
};

export default memo(InvoiceWidget);
